<!-- ======= Header ======= -->
<!-- before login header -->
<div class="fixed-top" *ngIf="!_common.getToken()">
    <div class="loginheader" >
      <div class="container-fluid" >
        <div class="row">
          <div class="col-xl-3 col-12 logob2c">
            <div class="logo">
              <a href="javascript:void(0);" class="b2clogolink">
                <i class="mobile-nav-toggle mobile-nav-show fa fa-align-left"></i>
                <i class="mobile-nav-toggle mobile-nav-hide d-none fa fa-close"></i>
                <img src="assets/img/{{env.host.name}}/logo.png"  alt="logo" class="loginlogo">
              </a>
            </div>
          </div>
          <div class="col-xl-9 login-signup-header" >
            <div class="dapp">
                <a href="javascript:void(0)" (click)="openModal(login)">Login</a>
            </div>
            <ul class="login-wrap ps-md-3" *ngIf="env.host.signUpActive">
              <li>
                  <a href="javascript:void(0)" routerLink="/signup" class=" b2clogin">signup</a>
                
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <header id="header" class="header d-flex align-items-center">
      <div class="align-items-center">
        <nav id="navbar" class="navbar">
          <ul>
            <li><a href="javascript:void(0)" class="active"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-inplay.png" [routerLink]="_common.getToken() ? ['/inplay'] : ['/guest/inplay']" > Inplay</a></li>
            <li><a href="javascript:void(0)"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-cricket.svg" [routerLink]="_common.getToken() ? ['/sports', 4] : ['/guest/sports', 4]"> Cricket</a></li>
            <li><a href="javascript:void(0)"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-tennis.svg" [routerLink]="_common.getToken() ? ['/sports', 2] : ['/guest/sports', 2]"> Tennis</a></li>
            <li><a href="javascript:void(0)"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-soccer.svg" [routerLink]="_common.getToken() ? ['/sports', 1] : ['/guest/sports', 1]"> football</a></li>
            <!-- <li><a href="javascript:void(0)"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-election.svg" [routerLink]="_common.getToken() ? ['/sports', 4] : ['/guest/sports', 4]"> Election</a></li> -->
            <li><a href="javascript:void(0)"><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/icon-casino.svg" [routerLink]="_common.getToken() ? ['/sports', 99999] : ['/guest/sports', 99999]"> Live Casino</a></li>
            <li><a href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/help'] : ['/help']" ><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/help.png"> Help</a></li>
          </ul>
        </nav><!-- .navbar -->
        
      </div>
    </header><!-- End Header -->

</div>
<!-- before login header -->

<!-- after login header -->
<app-topnav [freeplayHomePage]="true"></app-topnav>
<!-- after login header -->


  <!-- ======= slider Section ======= -->
<section class="newlogslider" [ngClass]="{'pt-55' : _common.getToken()}">
  <div class="page-banner-ctn">
  </div>
  <div class="swiper mySlider">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/banner1.jpeg">
        </div>
        <div class="swiper-slide">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/banner2.jpeg">
        </div>
        <div class="swiper-slide">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/banner3.jpeg">
        </div>
        <div class="swiper-slide">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/banner4.jpeg">
        </div>
      </div>
    </div>
</section><!-- End slider Section -->

<main>

  <div class="commentary">
      <div class="container">
          <div class="d-flex align-items-center">
              <i class="fa fa-volume-up"></i>
              <marquee>
                  Dear customer, if you have trouble visiting {{env.host.domain}}{{env.host.ext}}, please visit 
              </marquee>
          </div>
      </div>
  </div>

  <!-- desktop view -->
  <div class="container desktop_view">
      <div class="row py-3">
          <div class="col-md-6">
              <div class="swiper favSwiperOne">
                  <div class="swiper_title">
                      <span>favourite</span>
                      <div class="swiper-button-next"></div>
                      <div class="swiper-button-prev"></div>
                  </div>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/1.png">
                    </div>
                    <div class="swiper-slide active">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/2.png">
                    </div>
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/3.png">
                    </div>
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/4.png">
                    </div>
                  </div>
              </div>
          </div>

          <div class="col-md-6">
              <div class="swiper favSwiperOne">
                  <div class="swiper_title">
                      <span>favourite</span>
                      <div class="swiper-button-next"></div>
                      <div class="swiper-button-prev"></div>
                  </div>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/5.png">
                    </div>
                    <div class="swiper-slide active">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/6.png">
                    </div>
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/7.png">
                    </div>
                    <div class="swiper-slide">
                      <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/8.png">
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- desktop view -->

  <!-- mobile view -->
  <div class="bg-light-dark pt-2 pb-3 mobile_view">
      <div class="container">
          <div class="row">
              <div class="col-12">
                  <div class="swiper favmobile">
                      <div class="swiper_title">
                          <span>favourite</span>
                      </div>
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/1.png">
                        </div>
                        <div class="swiper-slide active">
                          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/2.png">
                        </div>
                        <div class="swiper-slide">
                          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/3.png">
                        </div>
                        <div class="swiper-slide">
                          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/4.png">
                        </div>
                      </div>
                      <div class="swiper-scrollbar"></div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-12">
                  <div class="swiper featuredSwiper">
                      <div class="swiper_title">
                          <span>Featured Games</span>
                      </div>
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/5.png" />
                          <h3>mony coming</h3>
                        </div>
                        <div class="swiper-slide">
                          <img lass="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/6.png" />
                          <h3>mony coming</h3>
                        </div>
                        <div class="swiper-slide">
                          <img lass="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/7.png" />
                          <h3>mony coming</h3>
                        </div>
                        <div class="swiper-slide">
                          <img lass="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/8.png" />
                          <h3>mony coming</h3>
                        </div>
                      </div>
                      <div class="swiper-scrollbar"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- mobile view -->

</main><!-- End #main -->

<!-- ======= Footer ======= -->
<footer id="footer" class="footer">
  <div class="container">
    <div class="row f_foot">
      <div class="col-md-3">
          <div class="d-flex align-items-start">
              <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/icon-24hr.png">
              <div class="text-wrap">
                  <!-- <h4>Customer Support</h4> -->
                  <h4>কাস্টমার সাচপািয</h4>
                  <h5>Available 24/7 to assist you</h5>
              </div>
          </div>
      </div>

      <div class="col-md-3">
          <div class="d-flex align-items-start">
              <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/icon-book.png">
              <div class="text-wrap">
                  <!-- <h4>New Member Guide</h4> -->
                  <h4>ডনউ কমম্বার গ্াইি</h4>
                  <h5>Check out FAQ and guides</h5>
                  <a href="https://freeplay24aff.com/new-member-guide" target="_blank">Explore Now</a>
              </div>
          </div>
      </div>

      <div class="col-md-3">
          <div class="d-flex align-items-start">
              <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/icon-ambassador.png">
              <div class="text-wrap">
                  <!-- <h4>Brand Ambassador</h4> -->
                  <h4>ব্র্যান্ড অযাম্বাচসির</h4>
                  <h5>Play with celebrity</h5>
                  <a href="https://freeplay24aff.com/promotion" target="_blank">Have Fun Now</a>
              </div>
          </div>
      </div>

      <div class="col-md-3">
          <div class="d-flex">
              <a href="javascript:void(0)"><img class="img-fluid w-100" src="https://speedcdn.io/assets/king-v8/landing02/android-en.png"></a>
          </div>
      </div>
    </div>

    <div class="footer-partner-wrap row">
          <div class="duty col-md-2 col-6">
              <h5>Responsible Gaming
              </h5>
              <a style="cursor: pointer;" target="_blank" href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/safe1.png">
              </a>
              <a style="cursor: pointer;" target="_blank" href="javascript:void(0);" routerLink="/pages/18_plus">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/safe2.png">
              </a>
              <a style="cursor: pointer;" target="_blank" href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/safe3.png">
              </a>
          </div>
          <div class="payment col-md-10 col-12">
              <h5>Payment Methods
              </h5>
              
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay16.png" alt="Bank Deposit">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay22.png" alt="bKash">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay33.png">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay34.png">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay45.png" alt="UPAY">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay59.png" alt="OKWallet">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay60.png" alt="SureCash">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay61.png" alt="tapPay">
              </a>
              <a href="javascript:void(0);">
                  <img src="https://speedcdn.io/assets/king-v8/landing02/pay47.png" alt="USDT">
              </a>
          </div>
          
          <div class="social-media col-md-12 col-6">
              <h5>Community Websites
              </h5>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/FaceBook.png" alt="FaceBook">
              </a>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/Instagram.png" alt="Instagram">
              </a>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/Twitter.png" alt="Twitter">
              </a>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/Pinterest.png" alt="Pinterest">
              </a>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/Youtube.png" alt="Youtube">
              </a>
              
              <a href="javascript:void(0);" target="_blank">
                  <img src="https://bj88.live//images/web/footer/color-white/Telegram.png" alt="Telegram">
              </a>
              
          </div>
          
          <div class="gaming-license col-md-12">
              <h5>Gaming License
              </h5><img src="https://bj88.live//images/web/footer/gaming_license.png">
          </div>
      </div>

      <div class="footer-license">
          <div class="license-cont">
              <h1 class="license-title">Top Betting Exchange Sites Bangladesh, India &amp; South East Asia
              </h1>
              <!-- <p>A betting exchange is practically an online tool that is designed for gamblers to bet directly against each other and not involve any of the traditional bookmakers. Cricket Betting indicates two ways of betting in a cricket match. The first one is to bet on the overall outcome of a live cricket match. The other one is based on the live cricket score of a team in the first 6 overs.<br>Online betting has developed as a booming industry in South East Asia especially in Bangladesh and India, where the bettors get to choose from an exciting range of Top Betting Exchange Sites in Bangladesh, India and others South East Asia Region.<br>If you find this interesting and are in search of a reliable and safe Cricket Betting Sites Bangladesh and India, then you should enroll with us. {{env.host.name}} is a reputed online gambling site in entire Asia. We focus on not only cricket predictions but also other exciting online gaming products.</p> -->
              <p>একটি বাজি এক্সচেঞ্জটি কার্ যত একটি অনলাইন সরঞ্জাম র্া িযুাড়িচের িনয সরাসডর এচক অপচরর
                ডবরুচে বাজি ধরার িনয এবং traditional ডতহ্যবাহ্ী বুকচমকারচের ককানও িড়িত না করার িনয
                ডিিাইন করা হ্চযচে। জিচকি বাজি একটি জিচকি মযাচে বাজি রাখার েুটি উপায ডনচেযশ কচর।
                প্রথমটি হ্'ল লাইভ জিচকি মযাচের সামডিক ফলাফচলর উপর বাজি রাখা। অনযটি প্রথম 6 ওভাচর
                একটি েচলর লাইভ জিচকি ককাচরর উপর ডভডি কচর।
                অনলাইন বাজি েডিণ পূব যএডশযায ডবচশষত বাংলাচেশ এবং ভারচত একটি উত্সাহ্ী ডশল্প ডহ্সাচব
                ডবকডশত হ্চযচে, কর্খাচন কবিাররা বাংলাচেশ, ভারত এবং অনযানয েডিণ পূব যএডশযা অঞ্চচল
                শীষ যস্থানীয বাজি ডবডনময সাইিগুডলর একটি উচিিনাপূণ যপডরসীমা কথচক কবচে ডনচত পাচর।
                আপডন র্ডে এটি আকষ যণীয বচল মচন কচরন এবং একটি ডনভযরচর্াগ্য এবং ডনরাপে জিচকি বাজি
                সাইিগুডল বাংলাচেশ এবং ভারচতর সন্ধাচন থাচকন তচব আপনার আমাচের সাচথ ভডতযহ্ওযা উডেত।
                {{env.host.name}} পুচরা এডশযার একটি নামী অনলাইন িযুার সাইি। আমরা ককবল জিচকি পূব যাভাসই নয, 
                অনযানয উচিিনাপূণ যঅনলাইন কগ্ডমং পণযগুডলচতও মচনাডনচবশ কডর।</p>
          </div>
      </div>

      <div class="footer-logo-wrap row">
          <div class="footer-logo col-3">
              <div class="logo data-image" onclick="location.href='/'" style="cursor: pointer; background-image: url('https://freeplay24.com/assets/img/freeplay24/logo.png');"></div>
          </div>
          <div class="link-wrap col-9">
              <ul>
                  <li>
                      <a href="https://freeplay24aff.com" target="_blank">
                          Affiliate
                      </a>
                  </li>
                  
                  <li>
                      <a href="javascript:void(0)" routerLink="/pages/responsible_gaming">
                          Responsible Gaming
                      </a>
                  </li>
                  <li>
                      <a href="javascript:void(0)" routerLink="/pages/about_us">
                          About Us
                      </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" routerLink="/help">
                        Help
                    </a>
                  </li>
                  
              </ul>
              <p>© 2023 {{env.host.name}} Copyrights. All Rights Reserved
              </p>
          </div>
      </div>


      <div class="mobile_btns" *ngIf="!_common.getToken()">
          <a href="javascript:void(0)" routerLink="/signup" class="mb_singup">
              sign up
          </a>
          <a href="javascript:void(0)" class="mb_login" (click)="openModal(login)">
              login
          </a>
      </div>
  </div>
</footer>

<app-footer *ngIf="_common.getToken()"></app-footer>
<!-- End Footer -->


<script src="assets/js/main.js"></script>
<script src="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js"></script>

<ng-template #login>
  <div class="modal-body">
    <!-- <h2>Welcome to {{env.host.domain}} <small>{{env.host.ext}}</small></h2> -->
    <app-login-page [loginFreeplay]="true" (closeLogin)="closeModel()" (forceChangePwd)="openAppMoadal(changePwd)"></app-login-page>
  </div>
</ng-template>

<ng-template #changePwd>
  <div class="modal-body">
    <div class="modal-header">
      <h5 class="modal-title">Change Password</h5>
      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <app-change-password class="modal-change-pwd" (openLogin)="openAppMoadal(login)"
      [isModal]="true"></app-change-password>
    <!-- <app-login (forceChangePwd)="forceChangePwd()"></app-login> -->
  </div>
</ng-template>